// This value is set automatically by the ViewEngine on page load
// and is available during document.ready
window.viewEngineName = null;

/**
 * Ajax-Related APIs
 * -----------------
 * NOTE: DO NOT use Eclipse auto-formatting functions on this file.
 */

/**
 * Singleton that manages AJAX requests
 */
window.portalAjax = (function() {
   var m_aLastRequestTime, m_strLastRequestedHash;

   function getPublicUrl() {
      return location.protocol + '//' + location.hostname.replace("my.", "www.");
   }

   /**
    * Prevent access to the personal URLs (such as my.c21.com)
    * This sometimes happens in Safari. This function redirects the
    * user to the public URL.
    */
   function preventPersonalUrlAccess() {
      // If we are NOT in an iFrame
      // (iFrames are the only legit access to my.c21.com)
      if (window == window.top) {
         // If this is NOT a public URL
         if (location.hostname.indexOf("my.") === 0) {
            // Return to the public url
            location.href = getPublicUrl() + location.pathname + location.search + location.hash;
         }
      }
      // Ensure we are not on century21-hr (fraud site)
      if (location.hostname.indexOf("century21-hr") > 0) {
         location.href = "http://www.century21.com/legal/fraudalert?src=hr";
      }
   }

   preventPersonalUrlAccess();

   //COOKIES

   //Create new cookie: Set the cookie key and value
   function setCookie(cookieKey, cookieValue) {
      setRawCookie("c21.loc." + cookieKey, cookieValue, "/", 7 * 24 * 60 * 60, true);
   }

   //Create new cookie: Set the cookie key and value
   function setRawCookie(cookieKey, cookieValue, cookiepath, maxAgeSeconds, wildcardDomain) {
	   //alert(cookieKey + ': ' + cookieValue);
	   var cookiedomain = "";
	   var options = { };
	   if(wildcardDomain) {
		   cookiedomain = window.cookieDomain ? window.cookieDomain : '.' + location.hostname.split('.').slice(1).join('.');
		   options.domain = cookiedomain;
	   }
	   if (cookiepath) {
	      options.path = cookiepath;
	   }
	   if (maxAgeSeconds) {
   	   var date = new Date();
	      date.setTime(date.getTime() + (maxAgeSeconds * 1000));
	      options.expires = date;
      }

	   if ($.cookie) $.cookie(cookieKey, cookieValue, options);
   }

   // Set visited cookie for session authorization
   if(getCookie("visited") == null || getCookie("visited").length <= 0) {
	   setCookie("visited",  new Date());
   }

   //Get the cookie by its key
   function getCookie(cookieKey) {
      var cookie = ($.cookie) ? $.cookie("c21.loc." + cookieKey) : null;
      return cookie ? unescape(cookie) : null;
   }

   //Delete the cookie by its key
   function removeCookie(cookieKey) {
	   var cookieName = "c21.loc." + cookieKey;
	   var options = { };
	   options.domain = window.cookieDomain ? window.cookieDomain : '.' + location.hostname.split('.').slice(1).join('.');
	   options.path = "/";
	   options.expires = "Thu, 01-Jan-1970 00:00:01 GMT";
	   if ($.cookie) $.cookie(cookieName, null, options);
   }

   //Get the search cookie search results link
   function generateSearchCookieLink(searchtype) {
	   var cookie = null;
	   if(searchtype == null || $.trim(searchtype).length <= 0) {
		   cookie = getCookie("LAST_SEARCH");
	   } else {
		   cookie = getCookie("LAST_" + searchtype);
		   if(cookie == null || cookie == "null" || $.trim(cookie).length <= 0) {
		      cookie = getCookie("LAST_SEARCH");
		   }
	   }
	   if(cookie == null || cookie == "null" || $.trim(cookie).length <= 0) {
		   return null;
	   }
	   cookie = cookie.replace(/__CANONICAL=[^&]+(&|$)/, "");
	   cookie = cookie.replace(/SUBVIEW=[^&]+(&|$)/, "");

	   //This is a handoff link
	   if(cookie.indexOf('__HANDOFF') != -1) {
		   cookie = cookie.replace("__HANDOFF=1", "");
		   return cookie;
	   }

	   var url = "/search.c21?" + cookie;
	   var newUrl = "/search.c21?";
	   var oParams = {};
	   var count = 1;
	   $.each(c21Helpers.queryToJSON(url.split("?")[1]),
		   function(strKey, strValue) {
	   			oParams[strKey.toLowerCase()] = strValue;
	   			if(count == 1) {
		   			newUrl = newUrl + strKey.toLowerCase() + "=" + strValue;
	   			} else {
	   				newUrl = newUrl + "&" + strKey.toLowerCase() + "=" + strValue;
	   			}
	   			count++;
	   	   });

	   return newUrl;
   }

   /**
    *
    * Generate IDX Listings Search cookie link
    *
    */
   function generateIDXSearchCookieLink() {
      var cookie = getCookie("LAST_IDXPROPERTIES");
	   if(cookie == null || cookie == "null" || $.trim(cookie).length <= 0) {
		   return null;
	   }
	   cookie = cookie.replace(/__CANONICAL=[^&]+(&|$)/, "");
	   cookie = cookie.replace(/SUBVIEW=[^&]+(&|$)/, "");

	   var url = "/idxsearch.c21?" + cookie;
	   var newUrl = "/idxsearch.c21?";
	   var oParams = {};
	   var count = 1;
	   $.each(c21Helpers.queryToJSON(url.split("?")[1]),
		   function(strKey, strValue) {
	   			oParams[strKey.toLowerCase()] = strValue;
	   			if(count == 1) {
		   			newUrl = newUrl + strKey.toLowerCase() + "=" + strValue;
	   			} else {
	   				newUrl = newUrl + "&" + strKey.toLowerCase() + "=" + strValue;
	   			}
	   			count++;
	   	   });

	   return newUrl;
   }

   /**
    * Set the hash to the specified value
    *
    * @param strHash  the value to set the hash to
    * @param bOverwrite
    * @param aHashModifications
    */
   function setHash(strHash, bOverwrite, aHashModifications) {
      var oParams, oHashParams = {}, sQuery;

      //sQuery = document.location.search.substring(1);
      oParams = new PortalParams(true).getParams();
      //c21Helpers.queryToJSON(sQuery);

      if (strHash || strHash == "") {
         oHashParams = c21Helpers.queryToJSON(strHash);
         if (aHashModifications) {
            $.each(aHashModifications, function(key, value) {
               if (value == null) {
                  delete oHashParams[key];
               } else {
                  oHashParams[key] = value;
               }
            });
         }

         $.each(oHashParams, function(key, value) {
            if (oParams[key] && oParams[key] == oHashParams[key]) {
               delete oHashParams[key];
            }
            oParams[key] = value;
         });
      }

      if (bOverwrite) {
         m_strLastRequestedHash = $.param(oParams);
      }

      document.location.hash = $.param(oHashParams);
   }

   /**
    * Get the current hash value
    * Example: http://example.com#myhash Returns: "myhash"
    *
    * @return {String}
    */
   function getHash() {
      return window.location.hash.substring(1);
   }

   /**
    * Fired when the hash changes
    *
    * @param event
    * @param ignoreEmpty  whether to ignore empty hashes
    */
   function onHashChange(event) {
      var strHash, strRelativePath;

      strHash = $.param(window.portalAjax.getParameters());

      // Don't load the same hash twice
      if (m_strLastRequestedHash === strHash) {
         return;
      }

      strRelativePath = document.location.pathname.substring(1);
      if (window.viewEngineName === 'suggest') {
         portalSearch.handleHash(c21Helpers.queryToJSON(strHash));
      } else if (window.viewEngineName === 'search') {
         portalResults.handleHash(c21Helpers.queryToJSON(strHash));
      } else if(window.viewEngineName === 'school'){
         SchoolDetails.handleHash(c21Helpers.queryToJSON(strHash));
      }
   }

   /**
    * Read the response data from a request and act appropriately
    *
    * @param data
    */
   function interpretResponseData(data, aHashModifications) {
      var strElementData, jElement;

      // NOTE: This is a hackish fix to support two completely different instruction sets
      // Ideally we would only be using the eco-style instruction set, but there is legacy
      // code from C21.com that has not been upgraded to use this.
      //
      // Is this the new eco-style instruction set?
      if (Array.isArray(data)) {
         $.each(data, function (index, instruction) {
            var jElement;
            var strAction = instruction.action;

            switch (strAction) {
               case 'htmlReplace':
                  jElement = $("#" + instruction.tag);

                  // Use triggerHandler() instead of trigger(), otherwise bubbling will occur
                  jElement.triggerHandler("beforePortalAjaxLoad");

                  try {
                     jElement.html(instruction.html);
                  } catch (e) {
                     if (window.console && console.error) {
                        console.error(e);
                     }
                  }

                  // Use triggerHandler() instead of trigger(), otherwise bubbling will occur
                  jElement.triggerHandler("portalAjaxLoadEvent");
                  break;

               case 'execute':
                  try {
                     eval(instruction.code);
                  } catch (e) {
                     handleErrors(['Sorry, an unhandled error has occured.']);
                  }
                  break;

               case 'error':
                  // This is handled by PageForm
                  break;

               default:
                  //alert("Error: Unknown Instruction [" + instruction.type + "]");
            }
         });
      } else {
         // C21.com Legacy Instruction Set
         $.each(data.instructions, function(index, instruction) {
            if (instruction.type === 'tag') {
               strElementData = data[instruction.data];
               jElement = $('#' + instruction.tag);
               jElement.html(strElementData);

               // Use triggerHandler() instead of trigger(), otherwise bubbling will occur
               jElement.triggerHandler('portalAjaxLoadEvent');
            } else if (instruction.type === 'execute') {
               try {
                  eval(data[instruction.code]);
               } catch (e) {
                  handleErrors(['Sorry, an unhandled error has occured.']);
                  //alert(e.description + '\n\n' + data[instruction.code]);
               }
            } else if (instruction.type === 'setHash') {
               aHashModifications[instruction.hashKey] = instruction.hashValue;
            } else {
               alert('Error: Unknown Instruction [' + instruction.type + ']');
            }
         });
      }
   }

   /**
    * Called on an AJAX response
    *
    * @param response
    * @param textStatus
    * @param XMLHttpRequest
    */
   function viewEngineAjaxResponse(response, textStatus, XMLHttpRequest, fnCallback) {
      var data;

      if (window.debugPortalAjax) {
         window.debugPortalAjax(this.subView, this.query, response);
      }

      // Disable the loading indicator
      if (this.loadingIndicator) {
         this.loadingIndicator.destroy();
      }

      // Disregard old requests in the same sub view
      if (this.requestTime < m_aLastRequestTime[this.subView]) {
         return;
      }

      data = responseToJson(response);

      // Only update the hash if it's requested
      var aHashModifications = {};
      interpretResponseData(data, aHashModifications);

      addButtonCaps();
      cyberFormUtility.emulatePlaceholder();

      if (fnCallback) {
         fnCallback();
      }

      for (var n in aHashModifications) { // Stupid hack because JS won't
                                           // let you check if an object
                                           // has children easily
         return setHash(this.query, true, aHashModifications);
      }

      if (this.updateHash) {
         setHash(this.query);
      }
   }

   function responseToJson(tResponse) {
      var oData = tResponse;

      if (typeof tResponse != "object") { // if it is an object, JSON is already parsed by jquery because of content type
         oData = $.parseJSON(tResponse);  // otherwise assume we got JSON without correct content type
      }

      return oData;
   }

   /**
    * Initializes portalAjax
    */
   function init() {
      m_aLastRequestTime = {};
      $(window).on('hashchange', onHashChange);
      $(document).ready(function() { setTimeout(onDocumentReady); });
   }

   /**
    * When the document is ready
    */
   function onDocumentReady() {
      if (getHash()) {
         onHashChange();
      }

      addButtonCaps();

      // This is a temporary fix for the agent search on the Super Bowl Home Page
      window.portalAjax.removeCookie("findYourAgent");

      initAjaxTemplates();
   }

   /**
    * Get all the parameters from the query string and hash as an object
    * Example: http://example.com/?banana=yellow#apple=red
    * Returns: { banana : 'yellow', apple : 'red' }
    *
    * @return {Object}
    */
   function getParameters() {
      return new PortalParams().getParams();
   }

   init();

   /**
    * The following functions probably don't belong in "PortalAjax"
    */
   function addButtonCaps() {
      $(".StandardBtn").each(function() {
         var jThis = $(this);
         if (!jThis.children(".StandardBtnCap").length) {
            $('<span class="StandardBtnCap"></span>').prependTo(jThis);
         }
      });
   }

   function scrollToTop() {
      var iTop = Math.max($("html").scrollTop(), $("body").scrollTop()),
          oOffset = $("#PageBody").offset(),
          iBodyTop = oOffset ? oOffset.top : -1;

      if (iBodyTop > 0 && iTop > iBodyTop) {
         $("html, body").animate({
            scrollTop: iBodyTop
         }, 1000);
      }
   }

   function initAjaxTemplates () {
      $(".ajaxTemplate").each(function () {
         var jThis = $(this),
            strJsonUrl = jThis.data("json-url"),
            strTemplateUrl = jThis.data("template-url"),
            strTemplateHtml,
            json,
            renderTemplate = function () {
               var strNewTemplate = strTemplateHtml.replace(/\[/g,"{").replace(/\]/g,"}");
               var strHtml = Mustache.to_html(strNewTemplate, json).replace(/^\s*/mg, '');
               jThis.html(strHtml).show();

               // If any JS needs to run after loading
               jThis.trigger("ajaxTemplateReplace");

               // Convenience
               jThis.find(".collapsasaurus").each(function () {
                  new Collapsasaurus($(this), 4, {
                     expandText : '&hellip;show more',
                     collapseText: '< less'
                  });
               });
            };

         $.getJSON(strJsonUrl, function (data) {
            json = data;
            if (strTemplateHtml) {
               renderTemplate();
            }
         });

         if (strTemplateUrl) {
            $.ajax({
               url: strTemplateUrl,
               success: function (result) {
                  strTemplateHtml = result;
                  if (json) {
                     renderTemplate();
                  }
               }
            });
         } else {
            strTemplateHtml = jThis.html();
            jThis.html("");
            if (json) {
               renderTemplate();
            }
         }
      });
   }

   function handleErrors(aStrErrors) {
      var strErrors = '';

      $.each(aStrErrors, function(i, strError) {
         strErrors += strError + '\n\n';
      });

      alert(strErrors);
   }

   return {
      responseToJson : responseToJson,
      getParameters : getParameters,
      setHash : setHash,
      getHash : getHash,
      setCookie: setCookie,
      getCookie: getCookie,
      removeCookie: removeCookie,
      generateSearchCookieLink: generateSearchCookieLink,
      generateIDXSearchCookieLink: generateIDXSearchCookieLink,

      /**
       * @return the personal URL
       * EX: my.c21.com
       */
      getPersonalUrl : function() {
         if (location.hostname.indexOf("www.") === 0) {
            return location.protocol + '//' + location.hostname.replace("www.", "my.");
         } else if (location.hostname.indexOf("www3.") === 0) {
            return location.protocol + '//' + location.hostname.replace("www3.", "my.");
         } else if (location.hostname.indexOf("espanol.") === 0) {
        	return location.protocol + '//' + location.hostname.replace("espanol.", "my.") + "/esp";
         } else if (location.hostname.indexOf("hispanic.") === 0) {
        	return location.protocol + '//' + location.hostname.replace("hispanic.", "my.") + "/esp";
         } else if (location.hostname === "c21.com") {
            return location.protocol + '//my.' + location.hostname;
         } else {
            return location.protocol + '//' + location.hostname;
         }
      },

      /**
       * @return the public URL
       * EX: www.c21.com
       */
      getPublicUrl : getPublicUrl,

      /**
       * Do an SEO-friendly AJAX call
       *
       * @param strSubView  the sub view associated with the request (ex: searchView.AllSubView)
       * @param strUrl      the url to call
       * @param strQuery    the query options
       * @param options     additional options
       */
      doViewEngineAjax : function(strSubView, strUrl, strQuery, options) {
         var iRequestTime, strRequestUrl, o = options || {},
            fnCallback, oRequestOptions, oData, strBaseUrl;

         iRequestTime = (new Date()).getTime();
         m_strLastRequestedHash = strQuery;
         m_aLastRequestTime[strSubView] = iRequestTime;

         if (o.callback) {
            fnCallback = function(response, textStatus, XMLHttpRequest) {
               viewEngineAjaxResponse.call(this, response, textStatus, XMLHttpRequest, function() {
                  options.callback(response, textStatus, XMLHttpRequest);
               });
            }
         } else {
            fnCallback = viewEngineAjaxResponse;
         }

         // Get the base URL
         // EX: http://www.c21.lbradley.century21.com
         strBaseUrl = (o.cache) ? window.portalAjax.getPublicUrl() : window.portalAjax.getPersonalUrl();

         // Combined url
         // EX: http://www.c21.lbradley.century21.com/myc21Overview.c21
         strRequestUrl = strBaseUrl + strUrl;

         // Interpret the data params
         if (typeof strQuery === "string") {
            oData = $.deparam(strQuery);
         } else {
            oData = {};
         }

         // Add correct subView to data params
         $.extend(oData, {
            subView: strSubView
         });

         oRequestOptions = {
            url: strRequestUrl,
            data: $.param(oData),
            cache: o.cache,
            callback: fnCallback,
            context: {
                  loadingIndicator : o.loadingIndicator,
                  subView : strSubView,
                  query : strQuery,
                  updateHash : o.updateHash,
                  requestTime : iRequestTime
               },
            requestType: o.requestType
         };

         // If we're caching
         if (o.cache === true) {
            window.portalAjax.doAjaxCall(oRequestOptions);

         // If we are not in the public c21 domain
         } else if (location.hostname.indexOf("www.") === 0 ||
               location.hostname.indexOf("www3.") === 0 ||
               location.hostname.indexOf("espanol.") === 0) {
            window.portalAjax.doPersonalAjax(oRequestOptions);
         }
      },

      /**
       * Allow a function to be run in the same DOMAIN as this frame
       * See: /js/iframe.proxy.html
       * @param fn  the function to call
       */
      callThisFrame: function(fn) {
         setTimeout(fn, 1);
      },

      /**
       * Shorthand for doViewEngineAjax
       * @param o {object} the options
       * @config {string} subView (ex: "FindAHomeSuggestLocation")
       * @config {string} url (ex: "/findahome.c21")
       * @config {string} [query] (ex: "t=1&lid=CAZPHOENIX")
       * @config {boolean} [cache] whether to aggressively cache the results
       * @config {function} [complete] function to call when the request is complete
       * @config {c21.LoadingIndicator} [loadingIndicator]
       */
      fetchView: function (o) {
         var strUrl = o.url || m_oViewEngineUrls[window.viewEngineName] || "/search.c21";
         window.portalAjax.doViewEngineAjax(o.subView, strUrl, o.query, o);
      },

      doPersonalAjax: function(oRequestOptions) {
         // Run AJAX in a different frame due to XSS restrictions
         var iInterval = setInterval(function() {
            if (window.proxyAjax) {
               clearInterval(iInterval);
               window.proxyAjax(oRequestOptions);
            }
         }, 20);
      },

      doAjaxCall: function(o) {
         $.ajax({
            url: o.url,
            data: o.data,
            success: o.callback,
            context: o.context,
            cache: o.cache ? true : false,
            type: o.requestType
         });
      },

      report: function(options) {
         var strRndId =  (Math.random() * 10000000000000).toString(),
            strRequestUrl = window.portalAjax.getPersonalUrl() + options.url
               + "?" + options.data + "&rnd=" + strRndId;

         window.portalAjax.doPersonalAjax({url: strRequestUrl});
      },

      /**
       * Request a sub-view
       *
       * @param strSubView   the sub-view the call is associated with
       * @param fnOnSuccess  the function to call on success
       * @param strQuery     the query string. Default is the current query string
       */
      requestSubView : function(strSubView, oParams, fnOnSuccess) {
         var strRequestUrl = "", strRequestQuery, strUrl, oRequestParams, strQuery;

         if (window.viewEngineName == 'localArea') {
            strUrl = '/localArea.c21';
         } else if (window.viewEngineName == 'school') {
            strUrl = '/school.c21';
         } else if (window.viewEngineName == 'property') {
            strUrl = '/property.c21';
         } else {
            strUrl = '/search.c21';
         }

         oRequestParams = getParameters();
         $.extend(oRequestParams, oParams);
         strQuery = $.param(oRequestParams);

         strRequestUrl = window.portalAjax.getPublicUrl() + strUrl + '?' + strQuery + '&subView=' + strSubView;

         $.ajax({
            url : strRequestUrl,
            success : fnOnSuccess,
            context : {
               subView : strSubView,
               query : strQuery
            }
         });
      },

      /**
       * Bind an AJAX load event to an element
       *
       * @param jElement  the jQuery element to bind to
       * @param fn        the function to bind
       */
      bindLoadEvent : function(jElement, fn) {
         jElement.on('portalAjaxLoadEvent', fn);

         // If the element exists
         if (jElement.length > 0) {
            // Call the event immediately
            fn();
         }
      },

      // These don't belong
      scrollToTop : scrollToTop,
      addButtonCaps : addButtonCaps,
      handleErrors : handleErrors,
   };
}());
